import { observer } from 'mobx-react'
import React from 'react'
import styled from 'styled-components'
import { mobile } from '../constants/breakpoints'

export const Page = styled.div`
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  padding-top: 50px;
  padding-bottom: 150px;

  background-color: #fff;
`

const InnerAppContent = styled.div`
  margin: 0 auto;
  border-radius: 8px;
  border: 1px solid #e6ddf9;
  background: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.07);

  width: 500px;
  box-sizing: border-box;
  padding: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;

  @media (max-width: 760px) {
    padding: 20px;
    width: 100%;
    border: none;
    background: transparent;
    box-shadow: none;
  }
`

const CompleteIconWrapper = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: var(--Radius-round, 100px);
  background: #f7f9fc;
`

const Title = styled.h2`
  margin: 30px 0 10px 0;
  color: var(--text-primary, #25292c);
  text-align: center;

  /* Headline 4 */
  font-family: Inter;
  font-size: var(--Fonts-Size-Headline-4, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: var(--Fonts-Line-height-Headline-4, 36px); /* 150% */
`

const Subtitle = styled.p`
  margin: 0;
  color: var(--text-primary, #25292c);
  text-align: center;

  /* Paragraph 3 - Regular */
  font-family: Inter;
  font-size: var(--Fonts-Size-Paragraph-3, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Fonts-Line-height-Paragraph-3, 24px); /* 150% */
  letter-spacing: -0.16px;
`

const PoweredBy = styled.div`
  position: absolute;
  bottom: -42px;
  right: 0px;

  color: var(--Text-disabled, #7f858b);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  display: flex;
  align-items: center;
  gap: 5px;

  @media (max-width: calc(${mobile})) {
    /* display: none; */
    margin-top: 40px;
    margin-right: 40px;
  }
`

export const SuccessPage = () => {
  return (
    <Page>
      <InnerAppContent>
        <CompleteIconWrapper>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
          >
            <path
              d="M50.794 34.1419C51.2406 33.7034 51.247 32.9858 50.8084 32.5392C50.3698 32.0927 49.6523 32.0862 49.2057 32.5248L36.4313 45.0711L31.4679 40.1077C31.0253 39.6651 30.3077 39.6651 29.8652 40.1077C29.4226 40.5503 29.4226 41.2679 29.8651 41.7105L36.4169 48.2623L50.794 34.1419Z"
              fill="#4C00FF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M72 40C72 57.6731 57.6731 72 40 72C22.3269 72 8 57.6731 8 40C8 22.3269 22.3269 8 40 8C57.6731 8 72 22.3269 72 40ZM69.7333 40C69.7333 56.4213 56.4213 69.7333 40 69.7333C23.5787 69.7333 10.2667 56.4213 10.2667 40C10.2667 23.5787 23.5787 10.2667 40 10.2667C56.4213 10.2667 69.7333 23.5787 69.7333 40Z"
              fill="#4C00FF"
            />
          </svg>
        </CompleteIconWrapper>
        <Title>Congratulations!</Title>
        <Subtitle>Your bank account has been created successfully.</Subtitle>

        <PoweredBy>
          Powered by:
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="47"
            height="25"
            viewBox="0 0 47 25"
            fill="none"
          >
            <path
              d="M23.9991 5.82431V1.4387H46.3587V23.3168H24.0036V18.9312V17.219L23.0822 18.6621C20.9388 22.019 17.129 24.2555 12.7843 24.2555C6.07096 24.2555 0.648438 18.9249 0.648438 12.3778C0.648438 5.83048 6.07108 0.5 12.7798 0.5C17.1289 0.5 20.9343 2.73646 23.0777 6.09339L23.9991 7.53647V5.82431Z"
              fill="#2A0062"
              stroke="#2A0062"
            />
            <g transform="translate(4.5, 7.5)">
              <path
                d="M3.4203 7.97144C4.95354 7.97144 5.97421 7.08513 5.97421 5.88884C5.97421 4.7493 5.19422 4.13805 3.73229 3.85426C2.86316 3.69271 1.98957 3.40892 1.98957 2.71472C1.98957 2.26065 2.41745 1.87207 3.18853 1.87207C3.9596 1.87207 4.64154 2.22572 4.64154 2.77148C4.64154 2.90682 4.60588 2.99851 4.57023 3.11203L5.61318 3.46568C5.72907 3.26047 5.81375 3.01161 5.81375 2.72345C5.81375 1.59701 4.75742 0.824219 3.2955 0.824219C1.84249 0.824219 0.893127 1.71053 0.893127 2.71035C0.893127 3.98524 1.85586 4.58775 3.35344 4.82789C4.46771 5.02436 4.81537 5.39547 4.81537 5.9194C4.81537 6.48699 4.29389 6.91049 3.43367 6.91049C2.63585 6.91049 1.90043 6.56994 1.90043 5.87574C1.90043 5.76222 1.92272 5.63561 1.95837 5.50026L0.915413 5.08112C0.808443 5.27759 0.714844 5.55702 0.714844 5.84518C0.723758 7.12879 1.74889 7.97144 3.4203 7.97144Z"
                fill="white"
              />
              <path
                d="M6.80469 1.80665C6.80469 2.18213 7.0944 2.46592 7.47771 2.46592C7.86102 2.46592 8.1641 2.18213 8.1641 1.80665C8.1641 1.43117 7.86547 1.13428 7.47771 1.13428C7.09886 1.13428 6.80469 1.43117 6.80469 1.80665Z"
                fill="white"
              />
              <path
                d="M8.00945 3.16895H6.95312V7.86681H8.00945V3.16895Z"
                fill="white"
              />
              <path
                d="M11.3007 6.97161C10.5207 6.97161 9.91901 6.43895 9.91901 5.53954C9.91901 4.54845 10.5252 3.95903 11.3007 3.95903C12.0896 3.95903 12.6824 4.59648 12.6824 5.46969C12.6779 6.34726 12.0762 6.97161 11.3007 6.97161ZM12.6334 3.16005V3.79749C12.3348 3.35215 11.8757 3.06836 11.1135 3.06836C9.8477 3.06836 8.83594 4.04635 8.83594 5.53518C8.83594 6.96724 9.79867 7.86665 11.0065 7.86665C11.8177 7.86665 12.3749 7.5261 12.62 7.024V7.5261C12.62 8.4124 12.2724 9.03675 11.3542 9.03675C10.6901 9.03675 10.1909 8.7093 10.0394 8.07185L9.07662 8.46916C9.42427 9.50392 10.2399 9.93616 11.3542 9.93616C12.8741 9.93616 13.6763 8.9145 13.6763 7.47807V3.15568H12.6334V3.16005Z"
                fill="white"
              />
              <path
                d="M15.8359 5.24265C15.8359 4.4131 16.3484 3.95467 16.9724 3.95467C17.5652 3.95467 17.9575 4.37381 17.9575 5.15097V7.87101H19.0138V4.79732C19.0138 3.6927 18.3051 3.06836 17.329 3.06836C16.7362 3.06836 16.1791 3.28666 15.818 3.84988V3.16441H14.7617V7.86228H15.818V5.23392L15.8359 5.24265Z"
                fill="white"
              />
              <path
                d="M23.0034 5.48276C23.0034 4.448 23.7611 3.95901 24.4207 3.95901C25.1294 3.95901 25.642 4.39124 25.7356 5.08545L26.6983 4.79292C26.4978 3.70141 25.584 3.06396 24.4207 3.06396C23.1059 3.06396 21.9961 4.04196 21.9961 5.48712C21.9961 6.97594 23.0079 7.96704 24.5723 7.96704C25.7356 7.96704 26.6983 7.3165 26.9524 6.0809L25.9896 5.74035C25.8827 6.43456 25.4771 7.08073 24.5277 7.08073C23.77 7.07636 23.0034 6.46948 23.0034 5.48276Z"
                fill="white"
              />
              <path
                d="M29.9123 7.03701C29.1546 7.03701 28.486 6.45633 28.486 5.53509C28.486 4.61385 29.1501 3.99824 29.9123 3.99824C30.621 3.99824 31.3519 4.57893 31.3519 5.53509C31.3386 6.49126 30.612 7.03701 29.9123 7.03701ZM31.3074 3.15559V3.91965C31.031 3.38699 30.4605 3.05518 29.6939 3.05518C28.3612 3.05518 27.4297 4.08993 27.4297 5.53509C27.4297 6.92349 28.3835 7.95825 29.6939 7.95825C30.4249 7.95825 30.982 7.66572 31.3653 7.07194V7.86656H32.3771V3.15559H31.3074Z"
                fill="white"
              />
              <path
                d="M35.7222 7.96275C36.627 7.96275 37.2421 7.41699 37.3357 6.47393L36.3239 6.27745C36.2883 6.82321 36.0654 7.07208 35.6598 7.07208C35.3612 7.07208 35.0537 6.8756 35.0537 6.42154V4.05514H36.8766V3.15573H35.0537V1.65381H34.0018V3.15573H33.0391V4.04204H34.0018V6.36914C33.9929 7.31221 34.55 7.96275 35.7222 7.96275Z"
                fill="white"
              />
              <path
                d="M19.957 1.80665C19.957 2.18213 20.2467 2.46592 20.6301 2.46592C21.0134 2.46592 21.3164 2.18213 21.3164 1.80665C21.3164 1.43117 21.0178 1.13428 20.6301 1.13428C20.2467 1.13428 19.957 1.43117 19.957 1.80665Z"
                fill="white"
              />
              <path
                d="M21.1657 3.16895H20.1094V7.86681H21.1657V3.16895Z"
                fill="white"
              />
            </g>
          </svg>
        </PoweredBy>
      </InnerAppContent>
    </Page>
  )
}
